<template>
  <v-card class="d-flex flex-column" style="height: 100vh">
    <v-card-title class="primary white--text d-flex align-center flex-shrink-0">
      <v-icon dark left>mdi-towel</v-icon>
      Hyrox Wettbewerb
      <v-spacer></v-spacer>
      <v-btn icon dark @click="$emit('close')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="pa-0" style="overflow-y: auto; flex-grow: 1">
      <v-container fluid class="pa-4 d-flex flex-column">
        <div v-if="!isHyroxListVisible" class="flex-grow-1 d-flex flex-column justify-center align-center text-center">
          <v-icon size="100" color="primary lighten-2">mdi-account-group-outline</v-icon>

          <div class="grey--text text--darken-2 mt-4" style="font-size: 1.25rem; font-weight: 500">Teilnehmer (Hyrox Wettbewerb)</div>

          <div class="display-3 font-weight-bold primary--text" style="line-height: 1.1; font-size: 6rem !important">
            <v-progress-circular v-if="loadingHyrox && displayHyroxCount === 0" indeterminate color="primary"></v-progress-circular>
            <span v-else>{{ Math.floor(displayHyroxCount) }}</span>
          </div>

          <p class="body-2 grey--text text--darken-2 mt-6 px-4" style="max-width: 500px">
            Hier werden alle Hyroxd Auto Wettbewerb Teilnehmer erfasst.
          </p>

          <v-tooltip bottom :disabled="!$moment().isBefore(startDate)">
            <template v-slot:activator="{ on }">
              <div v-on="on" class="mt-4">
                <v-btn :disabled="$moment().isBefore(startDate)" color="primary" @click="openAddLeadDialog" x-large rounded elevation="2">
                  <v-icon left>mdi-plus</v-icon>
                  Teilnehmer hinzufügen
                </v-btn>
              </div>
            </template>
            <span>Erfassung erst ab 16.01. möglich</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <v-btn text color="grey darken-1" @click="isHyroxListVisible = true" class="mb-4 mt-5" :disabled="loadingHyrox">
            <v-icon left>mdi-format-list-bulleted</v-icon>
            Teilnehmerliste anzeigen
          </v-btn>
        </div>

        <div v-else>
          <v-btn text @click="isHyroxListVisible = false" class="mb-2">
            <v-icon left>mdi-chevron-left</v-icon>
            Zurück zur Übersicht
          </v-btn>

          <v-card-actions class="pa-0 mb-4">
            <v-spacer></v-spacer>
            <v-tooltip bottom :disabled="!$moment().isBefore(startDate)">
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-btn :disabled="$moment().isBefore(startDate)" color="primary" @click="openAddLeadDialog" rounded elevation="2">
                    <v-icon left>mdi-plus</v-icon>
                    Teilnehmer hinzufügen
                  </v-btn>
                </div>
              </template>
              <span>Erfassung erst ab 01.11. möglich</span>
            </v-tooltip>
          </v-card-actions>

          <v-row class="mb-4" align="center">
            <v-col cols="12">
              <v-text-field
                v-model="searchHyrox"
                label="Hyrox Leads suchen (Name, E-Mail, Telefon...)"
                prepend-inner-icon="mdi-magnify"
                dense
                hide-details
                clearable
                outlined
                rounded></v-text-field>
            </v-col>
          </v-row>

          <v-data-table
            :headers="headersAlibey"
            :items="filteredHyroxLeads"
            :items-per-page="10"
            class="elevation-1 rounded-lg"
            :loading="loadingHyrox"
            loading-text="Lade Hyrox Leads..."
            :no-data-text="'Keine Leads für Hyrox gefunden.'"
            :no-results-text="'Keine Leads für diese Suche gefunden.'">
            <template v-slot:item.customerName="{ item }">
              <div class="d-flex align-center py-2">
                <v-avatar color="primary" size="36" class="white--text mr-4">
                  <span class="font-weight-bold">{{ getInitials(item.customerName) }}</span>
                </v-avatar>
                <div>
                  <div class="font-weight-bold">{{ item.surname }} {{ item.name }}</div>
                  <div class="text-caption grey--text">{{ item.email }}</div>
                </div>
              </div>
            </template>
            <template v-slot:item.contact="{ item }">
              <div v-if="item.phone">{{ item.phone }}</div>
            </template>
            <template v-slot:item.email="{ item }">
              <div v-if="item.email">{{ item.email }}</div>
            </template>
            <template v-slot:item.createdAt="{ item }">
              {{ formatDate(item.createdAt) }}
            </template>
            <template v-slot:item.address="{ item }">
              <div v-if="item.street || item.city" class="py-2">
                <div class="text-caption">{{ item.street }}</div>
                <div class="text-caption">{{ item.plz }} {{ item.city }}</div>
              </div>
            </template>

            <template v-slot:item.referral="{ item }">
              <div v-if="item.referralSource" class="text-caption">
                {{ item.referralSource }}
                <span v-if="item.referralSource === 'Andere' && item.referralSourceOther"> : {{ item.referralSourceOther }} </span>
              </div>
            </template>
          </v-data-table>
        </div>
      </v-container>
    </v-card-text>

    <v-dialog max-width="500px" v-model="addLeadDialog" persistent>
      <v-card>
        <v-card-title class="primary white--text"> <v-icon left dark>mdi-account-plus</v-icon> Neuer Wettbewerb Eintrag </v-card-title>
        <v-card-text class="pt-6">
          <v-form ref="addLeadForm" v-model="addLeadFormValid">
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field label="Vorname*" filled v-model="newLead.surname" :rules="[rules.required]" dense></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field label="Name*" filled v-model="newLead.name" :rules="[rules.required]" dense></v-text-field>
              </v-col>
            </v-row>
            <v-text-field label="E-Mail*" filled v-model="newLead.email" :rules="[rules.emailFormat, rules.required]" dense></v-text-field>
            <v-text-field label="Telefon*" filled v-model="newLead.phone" :rules="[rules.required]" dense></v-text-field>
            <v-text-field label="Strasse*" filled v-model="newLead.street" :rules="[rules.required]" dense></v-text-field>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field label="PLZ*" filled v-model="newLead.plz" :rules="[rules.required]" dense></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field label="Ort*" filled v-model="newLead.city" :rules="[rules.required]" dense></v-text-field>
              </v-col>
            </v-row>

            <v-text-field
              v-if="newLead.referralSource === 'Andere'"
              label="Andere (bitte angeben)*"
              v-model="newLead.referralSourceOther"
              :rules="[rules.requiredIfOther]"
              outlined
              dense
              class="mt-4"></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer> <v-btn text @click="addLeadDialog = false">Abbrechen</v-btn>
          <v-btn color="primary" @click="saveNewLead" :loading="savingLead" :disabled="!addLeadFormValid || savingLead" large elevation="2">
            Speichern
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import api from "@/api"
import { mapGetters } from "vuex"

export default {
  name: "HyroxCompetition",
  data() {
    return {
      tab: null, // Aktiver Tab
      startDate: "2026-01-16",
      mikrofaserPendingCount: 0,
      isHyroxListVisible: false, // NEU: Standardmässig auf false
      displayHyroxCount: 0, // NEU: Für den animierten Zähler
      showOnlyPending: true,
      // Data & Status für Alibey
      hyroxLeads: [],
      loadingHyrox: true,
      searchHyrox: "",
      headersAlibey: [
        { text: "Kunde", value: "customerName", sortable: true, width: "30%" },
        { text: "Telefon", value: "contact", sortable: false, width: "15%" },
        { text: "E-Mail", value: "email", sortable: false, width: "15%" },
        // NEU
        { text: "Adresse", value: "address", sortable: false, width: "25%" },
        // NEU (ersetzt 'notes')

        { text: "Erstellt am", value: "createdAt", sortable: true, width: "15%" },
      ],

      // Data & Status für Mikrofaser
      mikrofaserLeads: [],
      loadingMikrofaser: true,
      searchMikrofaser: "",

      // Für den "Lead hinzufügen" Dialog
      addLeadDialog: false,
      savingLead: false,
      // NEU: Optionen für das Dropdown
      referralOptions: ["Bestehendes Mitglied", "Inserat", "Flyer im Briefkasten", "Social Media Werbung", "Andere"],

      // NEU: Status der Formularvalidierung
      addLeadFormValid: false,

      // NEU: Validierungsregeln
      rules: {
        required: (value) => !!value || "Dieses Feld ist erforderlich.",
        requiredIfOther: (value) => {
          // Nur prüfen, wenn 'Andere' ausgewählt ist
          if (this.newLead.referralSource === "Andere") {
            return !!value || "Bitte angeben."
          }
          return true // Sonst immer gültig
        },
        emailFormat: (value) => {
          // Optional, aber WENN, dann valides Format
          if (!value) return true
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || "Ungültige E-Mail-Adresse."
        },
      },
      newLead: {
        name: "",
        surname: "",
        email: "",
        phone: "",
        // NEU: Felder für die Herkunft
        referralSource: null,
        referralSourceOther: "",
        // 'note' entfernt, wird jetzt generiert
      },
    }
  },

  computed: {
    ...mapGetters([]),

    filteredHyroxLeads() {
      if (!this.searchHyrox || this.searchHyrox.trim() === "") {
        return this.hyroxLeads
      }
      const search = this.searchHyrox.toLowerCase().trim()
      return this.hyroxLeads.filter((lead) => {
        const fullName = (lead.customerName || "").toLowerCase()
        const email = (lead.email || "").toLowerCase()
        const phone = (lead.phone || "").toLowerCase()

        // NEUE FELDER ZUR SUCHE HINZUFÜGEN
        const street = (lead.street || "").toLowerCase()
        const city = (lead.city || "").toLowerCase()
        const plz = (lead.plz || "").toLowerCase()
        const referral = (lead.referralSource || "").toLowerCase()
        const referralOther = (lead.referralSourceOther || "").toLowerCase()

        return (
          fullName.includes(search) ||
          email.includes(search) ||
          phone.includes(search) ||
          street.includes(search) ||
          city.includes(search) ||
          plz.includes(search) ||
          referral.includes(search) ||
          referralOther.includes(search)
        )
      })
    },
  },

  created() {
    this.fetchLeadsFromCompetition("hyrox-2026")
  },

  methods: {
    /**
     * NEU: Helper-Methode für die Avatare
     */
    getInitials(name) {
      if (!name) return "?"
      const parts = name.trim().split(" ")
      const surnameInitial = parts[0] ? parts[0][0] : ""
      const nameInitial = parts.length > 1 ? parts[parts.length - 1][0] : ""

      let initials = surnameInitial
      if (nameInitial && nameInitial !== surnameInitial) {
        initials += nameInitial
      }

      if (initials.length === 1 && name.length > 1) {
        initials = name.substring(0, 2)
      }

      return initials.toUpperCase()
    },

    /**
     * NEU: Die "SICK" Zähler-Animation
     */
    tweenCount(targetValue) {
      const startValue = this.displayHyroxCount
      // Wenn sich nichts ändert (z.B. bei schnellem Tab-Wechsel), nicht animieren
      if (startValue === targetValue && !this.loadingHyrox) return

      const duration = 1000 // 1 Sekunde Animation
      let startTime = null

      const animate = (currentTime) => {
        if (!startTime) startTime = currentTime
        const progress = Math.min((currentTime - startTime) / duration, 1)

        // Cubic Ease-Out (startet schnell, bremst sanft)
        const easeOutProgress = 1 - Math.pow(1 - progress, 3)

        const currentValue = Math.floor(easeOutProgress * (targetValue - startValue) + startValue)
        this.displayHyroxCount = currentValue

        if (progress < 1) {
          requestAnimationFrame(animate)
        } else {
          this.displayHyroxCount = targetValue // Am Ende exakten Wert setzen
        }
      }
      requestAnimationFrame(animate)
    },

    /**
     * Lädt Leads basierend auf dem Kampagnennamen.
     */
    async fetchLeadsFromCompetition(campaignName) {
      this.loadingHyrox = true

      try {
        const leads = await api.fetchCampaignLeads(campaignName)

        const leadsWithProps = leads.map((lead) => ({
          ...lead,
          loading: false,
          customerName: `${lead.surname || ""} ${lead.name || ""}`.trim(),
        }))

        if (campaignName === "hyrox-2026") {
          this.hyroxLeads = leadsWithProps
          // NEU: Animation des Zählers nach dem Laden auslösen
          this.tweenCount(leadsWithProps.length)
        } else {
          this.mikrofaserLeads = leadsWithProps
          this.mikrofaserPendingCount = leads.filter((lead) => lead.notes !== "tuch abgeholt").length
        }
      } catch (e) {
        console.error(`Fehler beim Laden der ${campaignName} Leads:`, e)
        this.$toast.error(`Fehler beim Laden der ${campaignName} Leads.`)
      } finally {
        if (campaignName === "hyrox-2026") {
          this.loadingHyrox = false
        } else {
          this.loadingMikrofaser = false
        }
      }
    },

    /**
     * Öffnet den Dialog zum Hinzufügen eines neuen Alibey-Leads.
     */
    openAddLeadDialog() {
      // NEU: Felder zurücksetzen
      this.newLead = {
        name: "",
        surname: "",
        email: "",
        phone: "",
        street: "", // Hinzugefügt
        plz: "", // Hinzugefügt
        city: "", // Hinzugefügt
        referralSource: null,
        referralSourceOther: "",
      }
      if (this.$refs.addLeadForm) {
        this.$refs.addLeadForm.resetValidation()
      }
      this.addLeadDialog = true
    },

    /**
     * Speichert den neuen Lead (Alibey).
     */
    async saveNewLead() {
      if (!this.$refs.addLeadForm.validate()) {
        this.$toast.error("Bitte alle Pflichtfelder (*) korrekt ausfüllen.")
        return
      }
      this.savingLead = true
      try {
        const payload = {
          name: this.newLead.name,
          surname: this.newLead.surname,
          email: this.newLead.email,
          phone: this.newLead.phone,

          // HIER DIE NEUEN FELDER HINZUFÜGEN
          street: this.newLead.street,
          plz: this.newLead.plz,
          city: this.newLead.city,

          type: "696113b43b7dfced85bb232b", // <-- BITTE ANPASSEN
          campaignName: "hyrox-2026",
        }

        await api.createWalkin(payload)
        this.$toast.success("Lead erfolgreich hinzugefügt.")
        this.addLeadDialog = false
        // NEU: Lädt die Liste neu. fetchLeads... löst dann automatisch
        // die Zähler-Animation aus.
        await this.fetchLeadsFromCompetition("hyrox-2026")
      } catch (e) {
        console.error("Fehler beim Speichern des Leads:", e)
        this.$toast.error("Fehler beim Speichern des Leads.")
      } finally {
        this.savingLead = false
      }
    },

    /**
     * Markiert ein Mikrofaser-Tuch als abgeholt.
     */
    async markTowelPickedUp(lead) {
      this.$set(lead, "loading", true)
      try {
        const updatedLead = { ...lead, notes: "tuch abgeholt" }
        await api.updateLead(updatedLead)
        this.$toast.success(`Tuch für ${lead.customerName} als abgeholt markiert.`)

        const index = this.mikrofaserLeads.findIndex((l) => l._id === lead._id)
        if (index > -1) {
          updatedLead.loading = false
          this.$set(this.mikrofaserLeads, index, updatedLead)
          this.mikrofaserPendingCount = this.mikrofaserLeads.filter((l) => l.notes !== "tuch abgeholt").length
        }
      } catch (e) {
        console.error("Fehler beim Aktualisieren des Leads:", e)
        this.$toast.error("Fehler beim Aktualisieren des Leads.")
        this.$set(lead, "loading", false)
      }
    },

    /**
     * Formatiert ein ISO-Datum oder einen Timestamp.
     */
    formatDate(isoString) {
      if (!isoString) return "-"
      return this.$moment(isoString).format("DD.MM.YYYY, HH:mm")
    },
  },
}
</script>

<style lang="scss" scoped>
/* Style für den "Feed"-Look im Mikrofaser-Tab */
.list-item-card {
  border: 1px solid #eee;
  border-radius: 12px;
  margin-bottom: 8px;
  background: #fff;
  transition: all 0.2s ease-in-out;

  &:hover {
    border-color: #ddd;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
  }
}

.action-button {
  margin-right: -4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
}

/* Sorgt dafür, dass die v-list nicht den Standard-Padding der v-card-text überschreibt */
.v-card__text {
  .v-tabs-items {
    .container {
      /* Wichtig für die Alibey-Zähler-Ansicht */
      &.d-flex {
        padding: 16px !important;
      }
    }
  }
}

/* Stellt sicher, dass der Tab-Inhalt die volle Höhe einnimmt */
.v-tabs-items,
.v-tab-item {
  // height: 100%;
}
</style>
